import { render, staticRenderFns } from "./AccessRequestPage.vue?vue&type=template&id=8b893304&scoped=true"
import script from "./AccessRequestPage.vue?vue&type=script&lang=js"
export * from "./AccessRequestPage.vue?vue&type=script&lang=js"
import style0 from "./AccessRequestPage.vue?vue&type=style&index=0&id=8b893304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b893304",
  null
  
)

export default component.exports